import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

import "./content.css";

import video1 from "../videos/homepage2.mp4";
import video2 from "../videos/video7.mp4";
import video3 from "../videos/video8.mp4";

function VideoCarousel() {
  const videoRefs = useRef([]);

  const videos = [video1, video2, video3];

  const handlePlay = (index) => {
    videoRefs.current.forEach((video, i) => {
      if (video && i !== index) {
        video.pause();
        video.currentTime = 0;
      }
    });

    if (videoRefs.current[index]) {
      videoRefs.current[index].currentTime = 0;
      videoRefs.current[index].play();
    }
  };

  const handleStop = (index) => {
    if (videoRefs.current[index]) {
      videoRefs.current[index].pause();
      videoRefs.current[index].currentTime = 0;
    }
  };

  return (
    <section className="video-section">
      <div className="video-container">
        <Swiper
          modules={[Navigation]}
          navigation
          loop={false}
          spaceBetween={25}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
          }}
        >
          {videos.map((video, index) => (
            <SwiperSlide key={index}>
              <div className="video-card">
                <video
                  ref={(el) => (videoRefs.current[index] = el)}
                  src={video}
                  muted
                  playsInline
                  preload="metadata"
                  onMouseEnter={() => handlePlay(index)}
                  onMouseLeave={() => handleStop(index)}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}

export default VideoCarousel;